// extracted by mini-css-extract-plugin
export default {"list":"ContactList_list__gNG+S","item":"ContactList_item__SgF3G"};